import React, { Component } from "react";
import { connect } from "react-redux";
import Drawer from "@material-ui/core/Drawer";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import { Button } from "@material-ui/core";
import NutritionalFacts from "./NutritionalFacts";
import { getCurrencyIcon } from "../../Helpers/currencyConverter";

export class Summary extends Component {
  state = {
    isMobile: false,
  };

  toggleDrawer = () => {
    window.scrollBy(0, 5);
    window.scrollBy(0, -5);
  };

  render() {
    const language = this.props.language;

    const {
      selectedProduct,
      showNutrition,
      nutritionalFacts,
      current_product,
      settings,
    } = this.props;

    let store_product = this.props.store.categories.find(
      (category) => category.id === current_product.category_id
    );

    if (current_product.parent) {
      store_product = store_product.products
        .find(
          (parent) =>
            parent.id === current_product.parent && parent.has_variants === true
        )
        .children.find((product) => product.id === current_product.id);
    } else {
      store_product = store_product.products.find(
        (product) => product.id === current_product.id
      );
    }

    const themeColor = this.props.themeColor
      ? this.props.themeColor
      : "#0099cc";
    const options = [];
    for (var group in this.props.current_item.options) {
      let OptionGroup = store_product.options.find(
        (optionGroup) => optionGroup.id === parseInt(group)
      );

      let choice = undefined;
      options.push(
        Object.keys(this.props.current_item.options[group].selectedOptions).map(
          (key, indx) => {
            choice = OptionGroup.choices.find((option) => option.id == key);
            return (
              <p
                className="text-muted m-0"
                style={{
                  fontSize: "0.9 rem",
                  whiteSpace: "nowrap",
                }}
                dir={language == "english" ? "ltr" : "rtl"}
              >
                {language == "english"
                  ? `${choice.value} x ${this.props.current_item.options[group].selectedOptions[key].quantity} /`
                  : `${choice.ar_value} x ${this.props.current_item.options[group].selectedOptions[key].quantity} /`}
              </p>
            );
          }
        )
      );
    }
    const currencyIcon = getCurrencyIcon(settings)

    return (
      <>
        <div className="mb-5 w-100 ">
          <Drawer
            className="h-100"
            anchor="bottom"
            PaperProps={{
              className: this.props.language === "arabic" ? "ml-auto" : "",
            }}
            open={this.props.visible}
            onClose={() => this.props.onClose()}
          >
            <div
              style={{
                backgroundColor: "white",
                overflowX: "hidden",
              }}
            >
              <div
                class={`  d-flex flex-row justify-content-between ${
                  language === "arabic" ? "flex-row-reverse" : ""
                }  `}
                onClick={() => this.props.onClose()}
              >
                <p class=" font-weight-bold my-auto mx-3 ">{`${
                  language === "english" ? "Summary" : "الملخص"
                }`}</p>
                <div class="mx-2">
                  <IconButton
                    edge="end"
                    aria-label="delete"
                    onClick={() => this.props.onClose()}
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
              </div>
              <div className="mx-3 my-2">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span style={{ fontWeight: "bold", fontSize: "13px" }}>
                    {language === "english"
                      ? this.props.current_item.name
                      : this.props.current_item.ar_name}{" "}
                    <span style={{ color: themeColor, fontWeight: "bold" }}>
                      x {this.props.current_item.quantity}
                    </span>{" "}
                  </span>
                  <span
                    className={
                      currencyIcon
                    }
                    style={{ color: themeColor, fontWeight: "bold" }}
                  >
                    {language === "english"
                      ? settings.currency_english
                      : settings.currency_local}{" "}
                    {this.props.current_item.total_price.toFixed(
                      settings.currency_decimals
                    )}
                  </span>
                </div>
              </div>
              <div
                className="mx-4"
                style={{
                  display: "flex",
                  whiteSpace: "nowrap",
                  flexWrap: "wrap",
                  gap: 5,
                  textAlign:
                    this.props.language === "arabic" ? "right" : "left",
                  marginBottom: 10,
                  marginTop: 7,
                }}
              >
                {options}
              </div>

              {showNutrition &&
                settings.show_nutrition_facts &&
                (nutritionalFacts?.totalCalories > 0 ||
                  nutritionalFacts?.totalCarbs > 0 ||
                  nutritionalFacts?.totalProtein > 0 ||
                  nutritionalFacts?.totalFats > 0 ||
                  nutritionalFacts?.isDairyFree ||
                  nutritionalFacts?.isSugarFree ||
                  nutritionalFacts?.isGlutenFree ||
                  nutritionalFacts?.isNutFree ||
                  nutritionalFacts?.isOrganic ||
                  nutritionalFacts?.isVegan ||
                  nutritionalFacts?.isVegetarian ||
                  nutritionalFacts?.containsGluten ||
                  nutritionalFacts?.containsNutsSesame ||
                  nutritionalFacts?.containsDairy ||
                  nutritionalFacts?.containsEgg ||
                  nutritionalFacts?.containsSeafoodShellfish ||
                  nutritionalFacts?.containsChilli) && (
                  <div>
                    <NutritionalFacts
                      nutritionalFacts={nutritionalFacts}
                      fromPage={"product"}
                    />
                  </div>
                )}

              <div
                style={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: 5,
                }}
              >
                <Button
                  style={{
                    backgroundColor: themeColor,
                    width: "95%",
                    color: "white",
                  }}
                  onClick={() => this.props.onClose()}
                >{`${language === "english" ? "Close" : "اغلاق"}`}</Button>
              </div>
            </div>
          </Drawer>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    themeColor: state.store.store.settings.dark,
    cart_items: state.cart.cart,
    settings: state.store.store.settings,
    store: state.store.store,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Summary);
